import { Cta, SanityCtaProps } from "@/components/cta"
import { RichText, RichTextValue } from "@/components/rich-text"
import { SlideOnView } from "@/components/slide-on-view"
import { GridBg } from "@/svgs/grid-bg"
import { cn } from "@/utils/cn"

interface TextCtaProps {
  content: {
    title: RichTextValue
    description: string
    cta: SanityCtaProps
    align: "left" | "center"
    bgColor: "white" | "blue"
    showGridBg: boolean
  }
}

export function TextCta({ content }: TextCtaProps) {
  return (
    <div
      className={cn(
        "relative flex",
        content.bgColor === "white"
          ? "bg-neutral-light text-neutral-dark"
          : "bg-primary-800 text-neutral-light",
        content.align === "center" ? "justify-center text-center" : "text-left"
      )}
    >
      {content.showGridBg && (
        <GridBg className="z-0 bg-neutral-light text-viola-500" />
      )}
      <div className="z-0 mx-5 py-20 md:mx-16 md:py-30 lg:mx-20 xl:mx-35">
        <SlideOnView>
          <RichText value={content.title} />
        </SlideOnView>
        <SlideOnView
          delay={0.2}
          className={cn(
            "mt-9 max-w-[62rem] text-[18px] lg:mt-4 xl:text-xlg",
            content.align === "center" && "mx-auto text-center"
          )}
        >
          {content.description}
        </SlideOnView>
        {content.cta?.label && (
          <SlideOnView
            delay={0.3}
            className={cn(
              "mt-8 flex",
              content.align === "left" ? "justify-start" : "justify-center"
            )}
          >
            <Cta sanity={content.cta} />
          </SlideOnView>
        )}
      </div>
    </div>
  )
}
